import React from "react";
import { NavLink } from "react-router-dom";
import "../assets/styles/components/MenuRoutes.sass";

const MenuVolcanRoutes = () => (
  <div className="row MenuRoutes -volcan">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuRoutes__list">
            <li className="MenuRoutes__list--item">
              <NavLink to="/volcan/carrera-volcan">CARRERA VOLCÁN</NavLink>
            </li>
            <li className="MenuRoutes__list--item">
              <NavLink to="/volcan/travesia-bosque">TRAVESÍA BOSQUE</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default MenuVolcanRoutes;
